/* ============================================================
   herQs — Kerstcadeau vriend / vader / heren
   GSAP entrance + scroll-reveal laag.

   Aanpak (robuust):
   - Reveal-targets worden door CSS verborgen, maar ALLEEN onder
     .vv-animate (toegevoegd door het head-script wanneer JS draait
     en motion OK is). We onthullen met gsap.to op scroll.
   - Geen gsap.from/immediateRender: dus geen risico op permanent
     onzichtbare content als een trigger ooit niet vuurt.
   - Failsafe: het head-script verwijdert .vv-animate na 3s als
     window.__vvAnimReady niet gezet is (GSAP niet geladen / fout)
     -> alles gewoon zichtbaar.
   - prefers-reduced-motion: head-script voegt .vv-animate niet toe
     en run() stopt -> alles zichtbaar.
   - Alleen verticale transforms (y) + opacity + lichte scale,
     nooit x -> geen horizontale overflow.
   ============================================================ */
(function () {
  var de = document.documentElement;

  function run() {
    // Shopify theme-editor (designMode): de editor rendert secties opnieuw in een
    // iframe waar de scroll-context onbetrouwbaar is -> scroll-reveals kunnen
    // misvuren of de layout doen schuiven. Sla animatie over en toon alles meteen.
    if (window.Shopify && window.Shopify.designMode) {
      de.classList.remove('vv-animate');
      return;
    }

    var gsap = window.gsap;
    var reduce = window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (!gsap || reduce) {
      de.classList.remove('vv-animate');
      return;
    }

    gsap.config({ nullTargetWarn: false });
    var ST = window.ScrollTrigger;
    if (ST) gsap.registerPlugin(ST);

    var EASE = 'power3.out';

    /* ---------- HERO entrance (op load) ---------- */
    var tl = gsap.timeline({ defaults: { ease: EASE } });
    tl.to('.vv-hero2 .vv-eyebrow', { opacity: 1, y: 0, duration: 0.6 })
      .to('.vv-hero2__h1',    { opacity: 1, y: 0, duration: 0.8 }, '-=0.35')
      .to('.vv-hero2__intro', { opacity: 1, y: 0, duration: 0.6 }, '-=0.50')
      .to('.vv-hero2__cta',   { opacity: 1, y: 0, duration: 0.6 }, '-=0.42')
      .to('.vv-hero2__proof', { opacity: 1, y: 0, duration: 0.5 }, '-=0.42')
      .to('.vv-hero2__usps li', { opacity: 1, y: 0, duration: 0.45, stagger: 0.08 }, '-=0.34');

    /* ---------- helpers (reveal = gsap.to vanuit CSS-hide) ---------- */
    function revealEach(sel, opts) {
      opts = opts || {};
      gsap.utils.toArray(sel).forEach(function (el) {
        gsap.to(el, {
          opacity: 1, y: 0, scale: 1, duration: opts.duration || 0.7, ease: EASE,
          scrollTrigger: { trigger: el, start: opts.start || 'top 85%' }
        });
      });
    }

    function revealGroup(triggerSel, itemsSel, opts) {
      opts = opts || {};
      var trigger = document.querySelector(triggerSel);
      var items = gsap.utils.toArray(itemsSel);
      if (!trigger || !items.length) return;
      gsap.to(items, {
        opacity: 1, y: 0, scale: 1,
        duration: opts.duration || 0.6, ease: EASE, stagger: opts.stagger || 0.12,
        scrollTrigger: { trigger: trigger, start: opts.start || 'top 80%' }
      });
    }

    /* ---------- sectiekoppen ---------- */
    revealEach('.vv-section .vv-head--center', { start: 'top 84%' });

    /* ---------- 02 Recipients ---------- */
    revealGroup('.vv-recipients__grid', '.vv-recipients__grid > .vv-rcard',
      { stagger: 0.14, start: 'top 80%' });

    /* ---------- 03 Product ---------- */
    revealEach('.vv-product__visual', { start: 'top 78%' });
    revealGroup('.vv-product__copy', '.vv-product__copy > *:not(.vv-specs)',
      { stagger: 0.1, start: 'top 80%' });
    revealGroup('.vv-specs', '.vv-specs > .vv-spec',
      { stagger: 0.06, duration: 0.55, start: 'top 86%' });

    /* ---------- 04 Voordelen ---------- */
    revealGroup('.vv-benefits__grid', '.vv-benefits__grid > .vv-benefit',
      { stagger: 0.1, start: 'top 82%' });
    revealEach('.vv-benefits__cta', { start: 'top 90%' });

    /* ---------- 05 Lifestyle ---------- */
    revealGroup('.vv-life__grid', '.vv-life__grid > .vv-life__tile',
      { stagger: 0.1, start: 'top 82%' });

    /* ---------- 06 Social proof ---------- */
    revealGroup('.vv-reviews__grid', '.vv-reviews__grid > .vv-review',
      { stagger: 0.12, start: 'top 82%' });
    revealGroup('.vv-stats', '.vv-stats > .vv-stat',
      { stagger: 0.1, duration: 0.55, start: 'top 86%' });

    /* ---------- 07 FAQ ---------- */
    revealGroup('.vv-faq__list', '.vv-faq__list > details',
      { stagger: 0.06, duration: 0.5, start: 'top 84%' });

    /* ---------- 08 Final CTA ---------- */
    revealGroup('.vv-final__inner', '.vv-final__inner > *',
      { stagger: 0.1, start: 'top 80%' });

    /* ---------- count-up op de stats (onEnter, één keer) ---------- */
    function fmt(el, v) {
      var dec = parseInt(el.getAttribute('data-dec') || '0', 10);
      var suf = el.getAttribute('data-suffix') || '';
      return v.toFixed(dec).replace('.', ',') + suf;
    }
    gsap.utils.toArray('.vv-count').forEach(function (el) {
      var to = parseFloat(el.getAttribute('data-to'));
      if (isNaN(to)) return;
      if (ST) {
        ST.create({
          trigger: el, start: 'top 90%', once: true,
          onEnter: function () {
            var proxy = { v: 0 };
            gsap.to(proxy, {
              v: to, duration: 1.4, ease: 'power1.out',
              onUpdate: function () { el.textContent = fmt(el, proxy.v); }
            });
          }
        });
      }
    });

    /* gereed: failsafe in <head> laat .vv-animate nu staan */
    window.__vvAnimReady = true;

    /* herbereken triggers zodra layout/fonts gesetteld zijn */
    setTimeout(function () { if (window.ScrollTrigger) window.ScrollTrigger.refresh(); }, 250);

    /* herbereken triggers nadat (lazy) beelden geladen zijn */
    window.addEventListener('load', function () {
      if (window.ScrollTrigger) window.ScrollTrigger.refresh();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
